// extracted by mini-css-extract-plugin
module.exports = {"card":"ProjectListItem_card__WiEs4","content":"ProjectListItem_content__3zj4b","title":"ProjectListItem_title__2w-ma","button":"ProjectListItem_button__2Vft_"};